<template>
    <div>
        <v-dialog
            v-model="dialogPaymentResult"
            width="800"
            style="min-width: 470px;"
        >
            <v-card>
                <v-card-title
                    class="headline grey lighten-2"
                    primary-title
                >
                    <span class="text-capitalize">{{ this.$t('paymentResult') }}</span>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="dialogPaymentResult = false" class="ma-0">
                        <v-icon>cancel</v-icon>
                    </v-btn>
                </v-card-title>

                <v-container grid-list-md fluid text-xs-left>
                    <v-layout row wrap>
                        <v-flex xs12 xl12 class="pt-0 pb-0">
                            <span>{{ this.$t('transactionStatus') }}: {{ paymentResultStatus }}</span>
                        </v-flex>
                        <v-flex xs12 xl12 class="pt-0 pb-0">
                            <span>{{ paymentResultMessage }}</span>
                        </v-flex>
                        <v-flex xs12 xl12 class="pt-0 pb-0">
                            <span>{{ this.$t('vnp_TxnRef') }}: {{ paymentResultInformation.vnp_TxnRef }}</span>
                        </v-flex>
                        <v-flex xs12 xl12 class="pt-0 pb-0">
                            <span>{{ this.$t('transactionNumber') }}: {{ paymentResultInformation.transaction_number }}</span>
                        </v-flex>
                        <v-flex xs12 xl12 class="pt-0 pb-0">
                            <span>{{ this.$t('transactionAmount') }}(VND): {{ paymentResultInformation.amount }}</span>
                        </v-flex>
                        <v-flex xs12 xl12 class="pt-0 pb-0">
                            <span>{{ this.$t('transactionTime') }}: {{ paymentResultInformation.created_time | formatDateTime}}</span>
                        </v-flex>
                        <v-flex xs12 xl12 class="pt-0 pb-0" v-if="dataReady">
                            <span>{{ this.$t('transactionBank') }}:  {{ paymentResultInformation.bank }}</span>
                        </v-flex>
                        <v-flex xs12 xl12 class="pt-0 pb-0" v-if="dataReady">
                            <span>{{ this.$t('transactionCardType') }}:  {{ paymentResultInformation.card_type }}</span>
                        </v-flex>
                        <v-flex xs12 xl12 class="pt-0 pb-0" v-if="dataReady">
                            <span>{{ this.$t('transactionOrderInfo') }}: {{ paymentResultInformation.order_info }}</span>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
// import { mapState } from 'vuex'
// import ApiService from '@/services/apis.service'
import ApiService from '@/services/apis.service'

export default {
    name: 'PaymentResult',
    data () {
        return {
            dialogPaymentResult: this.$route.query.vnp_ResponseCode,
            dataReady: false,
            paymentResultStatus: '',
            paymentResultMessage: '',
            paymentResultInformation: {
                'transaction_number': this.$route.query.vnp_TransactionNo,
                'amount': parseInt(this.$route.query.vnp_Amount) / 100,
                'bank': this.$route.query.vnp_BankCode,
                'card_type': this.$route.query.vnp_CardType,
                'order_info': this.$route.query.vnp_OrderInfo,
                'created_time': this.$route.query.vnp_PayDate,
                'vnp_TxnRef': this.$route.query.vnp_TxnRef
            }
        }
    },
    async mounted () {
        if (this.$route.query.vnp_ResponseCode) {
            await this.verifyPaymentInfo()
        }
    },
    methods: {
        async verifyPaymentInfo () {
            let queryString = window.location.href.split('?')[1]
            let respData = await ApiService.checkValidPayment(queryString)
            console.log(respData.data)
            if (respData.data['message'] === 'success') {
                this.dataReady = true
                this.paymentResultStatus = this.$t('successful')
                this.$appService.toastSuccess(this.$t('transactionSuccess'))
            } else {
                this.paymentResultStatus = this.$t('failed')
                let respCode = respData.data['response_code']
                this.paymentResultMessage = this.$t('transactionRespCode' + respCode)
                this.$appService.toastError(this.$t('transactionFail'))
            }
        }
    }
}
</script>

<style scoped>
    .box-pricing {
        border: 1px solid rgb(125, 125, 125);

    }

    .box-pricing button.can-buy-pack {
        width: 100%;
        color: #FFFFFF;
    }

    .box-pricing button.cant-buy-pack {
        width: 100%;
        background-color: #f5f5f5 !important;
    }

    .free {
        font-size: 30px;
        color: #4CA3DD;
        text-transform: uppercase
    }
</style>
